import { Link } from "react-router-dom";
import { pathConstants } from "../../../../routes/pathContants";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";

export const RestockFlowPrompt = () => {
  return (
    <div className={globalStyles.pageColumnGaps}>
      <Link
        className={`${globalStyles.cardWithBorder} ${globalStyles.noTextDecoration}`}
        to={pathConstants.INVENTORY_PRODUCTS_BULK_RESTOCK}
      >
        <h5>Fast-Track Procurement</h5>
        <p className="dark--text small-text-size">
          Create a purchase order. Receive and add goods to your stock position.
          Generate the bill in one simple step.
          <br />
          <span className="gray--text smallest-text-size">
            <span className="font-weight-bold dark--text">Best for:</span>{" "}
            Quick, low-risk purchases from trusted suppliers where speed matters
            most.
          </span>
        </p>
      </Link>
      <Link
        className={`${globalStyles.cardWithBorder} ${globalStyles.noTextDecoration}`}
        to={pathConstants.INVENTORY_PURCHASE_ORDER_CREATE}
      >
        <h5>3-Step Procurement (Recommended)</h5>
        <p className="dark--text small-text-size">
          Create a purchase order. Receive and add goods to your stock position.
          Generate the bill step by step with full control.
          <br />
          <span className="gray--text smallest-text-size">
            <span className="font-weight-bold dark--text">Best for: </span>
            Larger or higher-value orders from new suppliers where accuracy and
            control matter most.
          </span>
        </p>
      </Link>
    </div>
  );
};
